import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SUPPORT_ROUTE_URLS } from 'src/app/app.routes.names';
import { ModalHelper } from 'src/services/modal-helper.service';

@Component({
  selector: 'app-fourth-generation-page',
  templateUrl: './fourth-generation-page.component.html',
  styleUrls: ['./fourth-generation-page.component.scss']
})

export class IosFourthGenerationPageComponent implements OnInit {
  @Output() backToMain: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private router: Router,
    private modalHelper: ModalHelper) { }

  ngOnInit(): void { }

  public showLTEsettingPopUp(): void {
    this.modalHelper.ShowIosDataSetupModalComponent('4G')
      .afterClosed().subscribe((result) => {
        if (result) {
          // nothing to do 
        }
      }, (error) => {
        console.error('error', error);
      });
  }

  public back(): void {
    this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.ATT_IPHONE}`]);
  }
}
